import classNames from "classnames";

import Components from "../components";
import styles from "./gradient-card.module.scss";
import layoutStyles from "../Layout/layout.module.scss";
import { GradientCardStoryblok } from "@/types/component-types-sb";

interface Props {
  blok: GradientCardStoryblok;
}

export default function GradientCard(props: Props) {
  return (
    <div className={styles.wrapper}>
      {props?.blok?.content?.map((blok) => {
        const Component = Components(blok.component);

        return (
          <Component
            key={blok._uid}
            blok={blok}
            className={classNames(
              layoutStyles.layoutComponent,
              layoutStyles[blok.space_above],
              layoutStyles[blok.space_above_l]
            )}
          />
        );
      })}
    </div>
  );
}
